<script lang="typescript">
  import type { CalendarDay } from '../../common/types';
  import { createSelectDayEvent, service } from '../calendarmachine';
  import type { Context } from '../calendarmachine';
  import { calendar, selectedDay } from '../store';
  let context:Context;
  $: state = $service.machine.current;
  $: context = $service.context;
  $: error = context.error;
  $: weeks = $calendar.weeks;
  $: month = $calendar.month;
  const send = $service.send;
  const nextMonth = () => send({ type: 'next_month' });
  const previousMonth = () => send({ type: 'previous_month' });
  const refreshCurrent = () => send({ type: 'current_month' });
  const selectDay = (day:CalendarDay) => send(createSelectDayEvent(day));
  //FIXME
  $: monthName = month.month_name;
  $: year = month.year;
  $: weekdays = $calendar.weekday_names;
  $: isCalendarError = error !== undefined;
  $: loadingCalendar = state === 'fetching_month';
  /*
  */
</script>

<!--
<pre>
{JSON.stringify(state, null, 2)}
</pre>
<pre>
{JSON.stringify(calendar, null, 2)}
</pre>
<pre>
{JSON.stringify(calendar, null, 2)}
</pre>
<pre>
{JSON.stringify($service, null, 2)}
</pre>
<pre>
{JSON.stringify(weeks, null, 2)}
</pre>
<pre>
{JSON.stringify($state, null, 2)}
{JSON.stringify($bgState, null, 2)}
</pre>
<pre>
{JSON.stringify(selectedDay, null, 2)}
</pre>
-->

<div class="calendar">
  <div class="header">
    <h1>{monthName} {year}</h1>
    <div class="navigation">
      {#if isCalendarError}
        <span class="error">Virhe kalenterin haussa palvelimelta!</span>
      {/if}
      {#if loadingCalendar}
        <i class="fas fa-sync fa-spin" />
      {:else}
        <span on:click={refreshCurrent}>
          <i class="arrow fas fa-sync" />
        </span>
      {/if}
      <span on:click={previousMonth}>
      <i class="arrow fas fa-angle-left fa-lg" />
      </span>
      <span on:click={nextMonth}>
      <i class="arrow fas fa-angle-right fa-lg" />
      </span>
    </div>
  </div>
  <div class="month-week-numbers">
    <div class="week-number header">vko</div>
    {#each weekdays as weekday}
      <div class="week-day header">
        {weekday}
      </div>
    {/each}
    {#each weeks as week (week.week_number)}
      <div class="week-number">{week.week_number}</div>
      {#each week.days as day (day.day)}
        <div class="week-day"
             class:selected={$selectedDay.day == day.day}
             class:current={day.is_current_day}
             on:click={() => {
             selectDay(day);
             }}
             >
             <div class="date">
               {day.day_number}.{day.month_number}.
             </div>
             <div class="meetings">
               {#each day.meetings as meeting (meeting.id)}
                 <div class="meeting">
                   {meeting.start_time} {meeting.title}
                 </div>
               {/each}
             </div>
        </div>
      {/each}
    {/each}
  </div>
</div>

<style>

  div.month-week-numbers {
    border: 1px solid #000;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 0.8em;
  }

  .month-week-numbers div.week-number {
    min-width: 5%;
    max-width: 5%;
    padding: 6px;
  }

  .month-week-numbers div.week-day {
    min-width: 13.57%;
    max-width: 13.57%;
    padding: 6px;
  }

  .week-number {
    border-right: 1px solid #000;
    text-align: center;
    border-bottom: 1px solid #ccc;
  }

  .week-day {
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
    position: relative;
  }

  div.week-day.current {
    background-color: #fcbf54;
  }

  div.week-day.selected {
    background: #c766ab;
    color: #fff;
  }

  .week-day.selected .meeting {
    color: #fff;
  }

  .week-number.header,
  .week-day.header
  {
    border-bottom: 1px solid #000;
    cursor: auto;
  }

  .calendar {
    margin-bottom: 16px;
  }

  .calendar .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .calendar .header h1 {
    font-size: 1.2em;
  }

  .calendar .header .navigation i {
    margin-left: 12px;
  }

  .navigation .arrow {
    cursor: pointer;
  }


  .meeting {
    color: #333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0px;
    padding: 0px;
  }

  .date {
    font-weight: bold;
  }

</style>
